	export enum ScheduleTemplateApplicationFrequencyEnum {
		Every1Week = 1,
		Every2Weeks = 2,
		Every3Weeks = 3,
		Every4Weeks = 4,
		SpecificWeeks = 255
	}
